import { useState, useCallback } from 'react';
import deliveryOrderService from '../services/deliveryOrderService';
import i18n from '../i18n';

const useMySubOrders = () => {
    const [items, setItems] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState(null);
    const [detailLoading, setDetailLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchList = useCallback(async (params = {}) => {
        setLoading(true);
        setError(null);
        try {
            const res = await deliveryOrderService.getMySubOrders(params);
            if (res.success) {
                const data = res.data;
                setItems(Array.isArray(data?.items) ? data.items : Array.isArray(data) ? data : []);
                setTotal(data?.total ?? 0);
            } else {
                setError(res.error);
            }
        } catch (err) {
            setError(err?.message || i18n.t('hookErrors.common.unexpected'));
        } finally {
            setLoading(false);
        }
    }, []);

    const fetchDetail = useCallback(async (id) => {
        setDetailLoading(true);
        setDetail(null);
        try {
            const res = await deliveryOrderService.getSubOrderDetail(id);
            if (res.success) setDetail(res.data);
            return res;
        } catch (err) {
            setError(err?.message || i18n.t('hookErrors.common.unexpected'));
        } finally {
            setDetailLoading(false);
        }
    }, []);

    const clearDetail = useCallback(() => setDetail(null), []);

    return { items, total, loading, detail, detailLoading, error, fetchList, fetchDetail, clearDetail };
};

export default useMySubOrders;
